<template>
  <div>
    <div class="page">
      <el-divider></el-divider>
      <SiruiSearch
        :query="form"
        :columns="formColumn"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
      ></SiruiSearch>
      <div class="main-content">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          :loading="load"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="false"
          :columns="columnListDefault"
          :showToolbar="true"
          show-footer
          :footer-method="footerMethod"
          :valid-config="{ autoPos: true, message: 'inline' }"
          @chooseClick="chooseClick"
          @dblclickEvent="dblclickEvent"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnListDefault"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template v-slot="{ row }">
              <template v-if="item.field === 'waterMeterNo'">
                <a @click="jumpToMeterDetail(row)" href="#" style="color: blue; cursor: pointer">{{
                  row[item.field]
                }}</a>
              </template>
              <template v-else-if="item.field === 'waterMeterType'">{{
                getMeterType(row.waterMeterType)
              }}</template>
              <template v-else>{{ row[item.field] }}</template>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
    </div>
    <!--批量上传 -->
    <MeterUpload
      ref="siruiUpload"
      :isShowDownTemplateBtn="true"
      @getData="getReadList"
      :action="action"
      :data="importData"
    />
  </div>
</template>
<script>
  import API from '@/api/property/meterManagement';
  import MeterUpload from '@/pages/property/energyCibsynption/components/importDialog';
  import { indexColumn, tableColumn } from './columns/columns.js';
  export default {
    name: 'WaterMeterReading',
    components: { MeterUpload },
    computed: {
      formColumn() {
        return indexColumn(this);
      },
      //导入额外参数
      importData() {
        return {
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          belongTenantCode: this.userInfo.tenantCode,
          dataGroup: this.$globalVar.dataGroup,
          access_token: this.userInfo.access_token,
        };
      },
    },
    data() {
      return {
        form: {
          companyCode: '', //公司编码
          spaceAreaId: '', //区域
          spaceAssetId: '', //资产
          spaceUnitId: '', //单元
          spaceFloorId: '', //楼层
          spaceId: '', //房号
          customerName: '', //客户名称
          waterMeterNo: '', //电表编号
          waterMeterType: '', //电表类型
          readMeterMonthEnd: '', //起始月份
          readMeterDateStart: '',
          readMeterDateEnd: '',
          category: '',
        },
        exportForm: {},
        action: API.WATER_METER_READ_IMPORT,
        multipleSelection: [],
        menuButtonList: [],
        tableData: [], // 表格数据
        baseFormData: { instructionNo: '' },
        showAddPropertyDialog: false,
        showAddAreaDilaog: false,
        showAddUnitDialog: false,
        load: false,
        companyList: [],
        spaceAreaDisabled: true,
        spaceAreaList: [],
        spaceAssetDisabled: true,
        spaceAssetList: [],
        spaceUnitDisabled: true,
        spaceUnitList: [],
        spaceFloorDisabled: true,
        spaceFloorList: [],
        spaceDisabled: true,
        spaceList: [],
        columnListDefault: [],
      };
    },
    mounted() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      this.form.companyCode = this.userInfo.companyCode;
      this.columnListDefault = tableColumn();
      this.getButtonList();
      this.getCompany();
      this.getReadList();
    },
    methods: {
      // 底部合计
      footerMethod({ columns, data }) {
        const footerData = [
          columns.map((column, _columnIndex) => {
            if (_columnIndex === 0) {
              return '合计';
            }
            if (column.property === 'currentMonthRead') {
              return data.reduce((cur, next) => cur + +next.currentMonthRead, 0).toFixed(2);
            } else if (column.property === 'lossGap') {
              return data.reduce((cur, next) => cur + +next.lossGap, 0).toFixed(2);
            }
            return null;
          }),
        ];
        return footerData;
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      // 按钮点击
      chooseClick(value) {
        this[value]();
      },
      // 导入
      import() {
        this.$refs.siruiUpload.openDialog(true, '010');
      },
      getMeterType(type) {
        const meterType = {
          1: '总表',
          2: '单元水表',
          3: '楼层水表',
        };
        return meterType[type] || '房号水表';
      },
      jumpToMeterDetail(row) {
        this.$router.push({
          path: '/property/waterMeterReadDetail',
          query: { meterNo: row.waterMeterId },
        });
      },
      // 删除
      async delete() {
        this.$confirmAction('', '您确定要删除吗？').then(async () => {
          let idList = this.multipleSelection.map((item) => item.id);
          const { data } = await this.$axios.post(API.WATER_METER_READ_DELETE, idList);
          if (data.code == 0) {
            this.$message.success('删除成功');
            this.$refs.siruiTable.clearCheckboxReserve();
            this.multipleSelection = [];
            this.getReadList();
          } else {
            if (data.msg != '') {
              return this.$message.error(data.msg);
            }
            this.$message.error('删除失败');
          }
        });
      },
      register() {
        if (this.multipleSelection.length > 1) {
          this.$message.error('只能选择一条数据！');
        } else {
          if (this.multipleSelection.length > 0) {
            this.$router.push({
              path: '/property/waterMeterReadRegister',
              query: { meterNo: this.multipleSelection[0].waterMeterId },
            });
            this.$refs.siruiTable.clearCheckboxReserve();
            this.multipleSelection = [];
          } else {
            this.$router.push({ path: '/property/waterMeterReadRegister', query: { meterNo: '' } });
          }
        }
      },
      async export() {
        if (this.tableData.length == 0) {
          this.$message.error('暂无数据');
          return;
        }
        this.multipleSelection = this.$refs.siruiTable.getCheckboxRecords();
        var params = {};
        if (this.multipleSelection.length > 0) {
          params.ids = this.multipleSelection.map((item) => item.id);
          params.companyCode = this.exportForm.companyCode;
        } else {
          const { pageNum, pageSize } = this.$refs.siruiTable.page;
          this.exportForm.pageNum = pageNum;
          this.exportForm.pageSize = pageSize;
          params = this.exportForm;
        }
        params.template = false;
        const { data } = await this.$axios.post(API.WATER_METER_READ_EXPORT, params);
        if (data.code === 0) {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success',
          });
          window.location.href = data.data;
        } else {
          this.$alert(data.msg);
        }
      },
      //双击事件
      dblclickEvent(value) {
        this.$router.push({
          path: '/property/waterMeterReadDetail',
          query: { meterNo: value.row.waterMeterId },
        });
      },
      // 重置按钮
      resetBtnClick() {
        console.log('重置');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.form.companyCode = this.userInfo.companyCode;
        this.getReadList();
      },
      // 搜索按钮
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.getReadList();
      },
      // 页更改
      handleSizeChange() {
        this.getReadList();
      },
      handleCurrentChange() {
        this.getReadList();
      },
      // 选中的行
      handleSelectionChange(row) {
        this.multipleSelection = row;
        console.log(row);
      },
      //获取列表数据
      async getReadList() {
        let params = {
          ...this.form,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
          adminFlag: this.userInfo.adminFlag,
        };
        const { data } = await this.$axios.post(API.WATER_METER_READ_LIST, params);
        if (data.code == 0) {
          this.tableData = data.data.records;
          var str = JSON.stringify(this.form);
          this.exportForm = JSON.parse(str);
          this.$refs.siruiTable.setPageTotal(data.data.total);
          this.$refs.siruiTable.setPageSize(data.data.size);
        }
      },
      //获取公司信息
      async getCompany() {
        const { data } = await this.$axios.post(API.GET_LIST_PERSON, {
          id: this.userInfo.userCode,
        });
        if (data.code == 0) {
          this.companyList = data.data.personCompanyInfo;
        }
      },
      // 获取片区数据
      async getArea(value, type) {
        const { data } = await this.$axios.get(API.GET_AREA, {
          id: value,
          companyNo: this.form.companyCode,
        });
        if (data.code == 0) {
          if (type == 'area') {
            this.spaceAreaList = data.data;
            if (this.spaceAreaList.length <= 0) {
              this.form.spaceAreaId = '';
              this.form.spaceAssetId = '';
              this.form.spaceUnitId = '';
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
            }
          } else if (type == 'asset') {
            this.spaceAssetList = data.data;
            if (this.spaceAssetList.length <= 0) {
              this.form.spaceAssetId = '';
              this.form.spaceUnitId = '';
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
            }
          } else if (type == 'unit') {
            this.spaceUnitList = data.data;
            if (this.spaceUnitList.length <= 0) {
              this.form.spaceUnitId = '';
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
            }
          } else if (type == 'floor') {
            this.spaceFloorList = data.data;
            if (this.spaceFloorList.length <= 0) {
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
            }
          } else if (type == 'space') {
            this.spaceList = data.data;
            if (this.spaceList.length <= 0) {
              this.form.spaceId = '';
            }
          }
        }
      },
    },
    watch: {
      'form.companyCode': {
        handler: function (newVal) {
          console.log('公司值', newVal);
          if (newVal != '') {
            this.spaceAreaDisabled = false;
            this.getArea('0', 'area');
          } else {
            this.spaceAreaDisabled = true;
            this.spaceAssetDisabled = true;
            this.spaceUnitDisabled = true;
            this.spaceFloorDisabled = true;
            this.spaceDisabled = true;
            this.form.spaceAreaId = '';
            this.form.spaceAssetId = '';
            this.form.spaceUnitId = '';
            this.form.spaceFloorId = '';
            this.form.spaceId = '';
            this.spaceAreaList = [];
            this.spaceAssetList = [];
            this.spaceUnitList = [];
            this.spaceFloorList = [];
            this.spaceList = [];
          }
        },
      },
      'form.spaceAreaId': {
        handler: function (newVal) {
          console.log('公司值', newVal);
          if (newVal != '') {
            this.spaceAssetDisabled = false;
            this.getArea(newVal, 'asset');
          } else {
            this.spaceAssetDisabled = true;
            this.spaceUnitDisabled = true;
            this.spaceFloorDisabled = true;
            this.spaceDisabled = true;
            this.form.spaceAssetId = '';
            this.form.spaceUnitId = '';
            this.form.spaceFloorId = '';
            this.form.spaceId = '';
            this.spaceAssetList = [];
            this.spaceUnitList = [];
            this.spaceFloorList = [];
            this.spaceList = [];
          }
        },
      },
      'form.spaceAssetId': {
        handler: function (newVal) {
          if (newVal != '') {
            this.spaceUnitDisabled = false;
            this.getArea(newVal, 'unit');
          } else {
            this.spaceUnitDisabled = true;
            this.spaceFloorDisabled = true;
            this.spaceDisabled = true;
            this.form.spaceUnitId = '';
            this.form.spaceFloorId = '';
            this.form.spaceId = '';
            this.spaceUnitList = [];
            this.spaceFloorList = [];
            this.spaceList = [];
          }
        },
      },
      'form.spaceUnitId': {
        handler: function (newVal) {
          console.log('公司值', newVal);
          if (newVal != '') {
            this.spaceFloorDisabled = false;
            this.getArea(newVal, 'floor');
          } else {
            this.spaceFloorDisabled = true;
            this.spaceDisabled = true;
            this.form.spaceFloorId = '';
            this.form.spaceId = '';
            this.spaceFloorList = [];
            this.spaceList = [];
          }
        },
      },
      'form.spaceFloorId': {
        handler: function (newVal) {
          console.log('公司值', newVal);
          if (newVal != '') {
            this.spaceDisabled = false;
            this.getArea(newVal, 'space');
          } else {
            this.spaceDisabled = true;
            this.form.spaceId = '';
            this.spaceList = [];
          }
        },
      },
    },
  };
</script>
<style scoped lang="scss">
  .button-group {
    margin-top: 20px;
  }
  .form {
    margin-top: 20px;
    margin-left: 40px;
  }
  .item-margin {
    margin-left: 50px;
  }
  .page {
    background-color: white;
    margin-top: 0px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    height: 100%;
    top: 0;
    .page-row {
      text-align: right;
      margin-right: 20px;
      margin-bottom: 10px;
    }
    .el-divider--horizontal {
      display: block;
      height: 0.5px;
      width: 100%;
      margin: 1px 0;
    }
  }
</style>
